<div class="state h-100 w-100 d-flex justify-content-center py-4">
	<div class="spinner-container">
		<div class="spinner"></div>
	</div>
</div>
